module.exports = __webpack_public_path__ + "static/media/new-tentens.2678a15a.png";